import { render, staticRenderFns } from "./WideNav.vue?vue&type=template&id=7da485c8&scoped=true&"
import script from "./WideNav.vue?vue&type=script&lang=js&"
export * from "./WideNav.vue?vue&type=script&lang=js&"
import style0 from "./WideNav.vue?vue&type=style&index=0&id=7da485c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da485c8",
  null
  
)

export default component.exports